"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var questions = [{
  prompt: "What do you predict will happen if you don’t get enough sleep?",
  type: "multiSkip",
  meta: {
    answerLabel: "My prediction is",
    summaryTitle: "Your prediction if you don't get enough sleep was...",
    responsePrefix: "My predictions are: ",
    noResponsePrefix: "I don't anything will happen"
  },
  options: ["Won’t be able to concentrate", "Will make more mistakes", "Won’t be able to communicate as well with others", "Will feel tired and exhausted all day"],
  batteryId: "RETRAINING_THINKING_SLEEP_PREDICTIONS"
}, {
  prompt: "What is the worst thing that could happen if you don’t get enough sleep?",
  type: "textarea",
  meta: {
    answerLabel: "Worst thing that can happen is",
    summaryTitle: "The worst thing that can happen if you don't get asleep was"
  },
  batteryId: "RETRAINING_THINKING_SLEEP_PREDICTIONS"
}, {
  prompt: "What are the reasons why your predictions aren’t likely to be 100% true?",
  type: "multiSkip",
  meta: {
    answerLabel: "My prediction is not true because",
    summaryTitle: "Your prediction is not 100% true because",
    responsePrefix: "My prediction is not true because: ",
    noResponsePrefix: "I don't have any reasons why it won't be true"
  },
  options: ["I’ve been able to concentrate ok without much sleep in the past", "I don’t make many more mistakes than usual on reduced sleep", "No one has mentioned that I can’t communicate as well on reduced sleep", "I occasionally notice feeling tired on reduced sleep but it’s not a constant feeling"],
  batteryId: "RETRAINING_THINKING_SLEEP_PREDICTIONS"
}, {
  prompt: "What’s the main evidence that shows you don’t completely fall apart on reduced sleep?",
  type: "textarea",
  meta: {
    answerLabel: "Even on reduced sleep I can still...",
    summaryTitle: "What’s the main evidence that shows you don’t completely fall apart on reduced sleep?"
  },
  batteryId: "RETRAINING_THINKING_SLEEP_PREDICTIONS"
}, {
  prompt: "Given what you’ve done in this exercise, what is a balanced thought you can use if you get stuck worrying about predictions next time?",
  type: "textarea",
  meta: {
    answerLabel: "My balanced thought is..",
    summaryTitle: "A balanced thought you can use if you get stuck worrying about predictions next time?"
  },
  batteryId: "RETRAINING_THINKING_SLEEP_PREDICTIONS"
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;